import React, { useState } from 'react'
import OfficeImg from "../assets/office2.png"
import { api } from '../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'


// organization branch join requests received
const RequestingBranchCard = ({ b }) => {
    const [loadingAdd, setLoadingAdd] = useState(false)
    const [loadingRemove, setLoadingRemove] = useState(false)

    const { organization } = useParams()

    const handleRemove = async (id) => {
        try {
            setLoadingRemove(true)
            const response = await api.patch(`/${organization}/branches/requests/received`, { id })
            if (response) {
                setLoadingRemove(false)
                toast.success("branch request removed")
            }
        } catch (error) {
            setLoadingRemove(false)
            toast.error(error.response.data.message)
        } finally { setLoadingAdd(false) }
    }
    const handleAccept = async (id) => {
        try {
            setLoadingAdd(true)
            const response = await api.post(`/${organization}/branches/requests/received`, { id })
            if (response) {
                setLoadingAdd(false)
                toast.success("branch request Accepted")
            }
        } catch (error) {
            setLoadingAdd(false)
            toast.error(error.response.data.message)
        } finally { setLoadingAdd(false) }
    }
    return (
        <div className="branch-info">
            <img src={b.logo ? b.logo : OfficeImg} alt="" />
            <div className="branch-desc">
                <h3>{b.name}</h3>
                <p>
                    {b.description
                        ? b.description.length > 50
                            ? `${b.description.substring(0, 50)}...`
                            : b.description
                        : "No description available"}
                </p>
                <button className="branch-action-card-btn" onClick={() => handleRemove(b._id)}>{!loadingRemove ? "remove" : "..."}</button>
                <button className="branch-action-card-btn" onClick={() => handleAccept(b._id)}>{!loadingAdd ? "Accept" : "..."}</button>
            </div>
        </div>
    )
}

export default RequestingBranchCard